/*
===============================================================================================================
                                 Copyright 2025-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

export const PERMISSIONS_ENUM = {
  case: {
    read: 'case.read',
  },
  config: {
    read: 'config.read',
  },
  warehouse: {
    create: 'warehouse.create',
    read: 'warehouse.read',
    update: 'warehouse.write',
    delete: 'warehouse.delete',
  },
  rule: {
    create: 'rule.create',
    read: 'rule.read',
    update: 'rule.write',
    delete: 'rule.delete',
  },
  company: {
    admin: 'company.admin',
    create: 'company.create',
    read: 'company.read',
    update: 'company.write',
    delete: 'company.delete',
  },
  carrier: {
    create: 'company.write',
    update: 'company.write',
  },
  users: {
    create: 'user.create',
    read: 'user.read',
    update: 'user.write',
  },
  email: {
    write: 'email.write',
  },
  assets: {
    create: 'asset.create',
    update: 'asset.write',
  },
  order: {
    create: 'order.create',
  },
  purchase: {
    create: 'purchase.create',
  },
};

export const CONTROL_LEVEL = {
  hide: 'hide',
  disable: 'disable',
};
